<template>
  <div v-show="show" :style="{ 'z-index': (currentZIndex-1)}">
    <div :style="{ 'z-index': (currentZIndex)}"
      class="dimmed_black" style="top:0;display:block;"></div>
    <!--popup 시작-->
    <div :style="{ 'z-index': (currentZIndex+1)}"
      class="rew19_popContainer big" id="pop_cancelAro" style="display:block;">
      <div class="rew19_popup_wrap">
        <h2>
          <span class="rew19_basketList_tit">NTC 장바구니 선택</span>
          <button class="rew19_basketList_btn" @click="onCancel"><span>닫기</span></button>
        </h2>
      </div>
      <div class="rew19_popup_cont">
        <div class="rew19_centerMsg">
          고객님은 이미 NTC 정기기부를 이용 중입니다.<br/>
          NTC 정기기부는 1건만 약정이 가능합니다.<br/>
          기존 NTC 정기기부 약정에 상품을 추가하시겠습니까? 
        </div>        
        <h3 class="rew19_third_title">기존 NTC 정기기부에 상품 추가</h3>
        <ul class="rew19_underline_list">
          <li class="type1">
            <div class="rew19_wrapRadio_t1">
              <input type="radio" class="rew19_fakeRadio_t1"
                v-model="viewData.resData.addTo" :value="viewData.rawData.ntcNo"
                :id="'fakeRadio_1'" checked>
              <label :for="'fakeRadio_'+viewData.rawData.ntcNo">
                정기기부 번호 {{viewData.rawData.ntcNo}} ({{$fmt.WON(viewData.rawData.totalPrice)}}원)
              </label>
            </div>
          </li>          
        </ul>
      </div><!--//rew19_popup_cont-->

      <div class="rew19_popup_btn rew19_clear">
          <button class="rew19_popHarf disabled" @click="onCancel">취소</button>
          <button class="rew19_popHarf activation" @click="onOk">확인</button>
      </div>
    </div>  
  </div>  
</template>
<script>
import * as ErrMsg from "@/utils/error_msg";

const DEFAULT_ARO_INFO = {
  rawData : {
    ntcNo : "",
    //...
  },  
  resData : {
    addTo : "", //aro_no:기존Aro에 추가
    aroData : null,
  }      
}

export default {
  name: 'NtcCartAddDialog',
  components: { },
  props: {
    show: {
      type: Boolean,
      default: false
    },      
  },
  data() {
    return {      
      currentZIndex : 2000,

      viewData : DEFAULT_ARO_INFO,      
    }
  },
  updated: function () {
    this.$nextTick(function () {
      $(".rew19_popContainer.big .rew19_popup_cont").css('height', $(window).height() - 102); 
    })
  },
  watch: {
    show(show) {
      this.$modalAfterTreat(show);
      
      show && this.$nextTick(() => {
        let _this = this;
        _this.currentZIndex = _this.$getDimmMaxIndex() + 2;

        this.$el.focus();
      })
    }
  },
  mounted() {
    let _this = this;
  },  
  methods :{
    onClose(response) {
      let _this = this;

      _this.$emit('close', response, response ? _this.viewData : null);
    },
    onCancel(){
      this.onClose(false);
    },
    onOk() {
      this.onClose(true);
    },

    /**
     * API Request
     */    
    
    /**
     * Local 
     */
    initData : function(paramData){
      let _this = this;

      _this.viewData = {...DEFAULT_ARO_INFO, ...paramData};      
      
      _this.viewData.resData.addTo = _this.viewData.rawData.ntcNo;
      _this.viewData.resData.aroData = _this.viewData.rawData;
    },
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/popup/NtcCartAddDialog.vue